import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const AIHistoryIndividualPageDetailsLoading = () => {
    return (
        <Grid
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: { xs: 'flex-start', md: 'flex-end' },
                gap: 2,
                flexDirection: { xs: 'column', md: 'row' },
            }}
        >
            <Grid
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Skeleton
                    variant='text'
                    sx={{
                        fontSize: '1.4rem',
                        width: '130px',
                    }}
                />
                <Grid sx={{ display: 'flex', gap: 3 }}>
                    {' '}
                    <Skeleton
                        variant='text'
                        sx={{
                            fontSize: '1.4rem',
                            width: '140px',
                        }}
                    />
                    <Skeleton
                        variant='text'
                        sx={{
                            fontSize: '1.4rem',
                            width: '200px',
                        }}
                    />
                </Grid>
            </Grid>
            <Grid
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                    cursor: 'pointer',
                }}
            >
                <Skeleton
                    variant='text'
                    sx={{
                        fontSize: '1.4rem',
                        width: '200px',
                    }}
                />
                <Skeleton
                    variant='text'
                    sx={{
                        fontSize: '1.4rem',
                        width: '170px',
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default AIHistoryIndividualPageDetailsLoading;
